// extracted by mini-css-extract-plugin
export default {"select":"ModifierDropdown_select__ACo8B","buffer":"ModifierDropdown_buffer__P1ptM"};